export const makePostJson = (fetchFn)=>async (url, body)=>{
        const { ok, status } = await fetchFn(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
        return {
            ok,
            status
        };
    };
